export interface ReturningHero {
  displayName: string;
  email: string;
  heroSlug: string;
}

const RETURNING_HERO_KEY = "edu_game_returning_hero";
const RETURNING_HERO_VERSION = 1;

interface StoredReturningHero extends ReturningHero {
  version: typeof RETURNING_HERO_VERSION;
}

export function getReturningHero(): ReturningHero | null {
  try {
    const stored = window.localStorage.getItem(RETURNING_HERO_KEY);
    if (!stored) {
      return null;
    }

    const value = JSON.parse(stored) as Partial<StoredReturningHero>;
    if (value.version !== RETURNING_HERO_VERSION
      || typeof value.displayName !== "string"
      || typeof value.email !== "string"
      || typeof value.heroSlug !== "string"
      || value.displayName.trim().length === 0
      || !value.email.includes("@")
      || value.heroSlug.trim().length === 0) {
      return null;
    }

    return {
      displayName: value.displayName.slice(0, 40),
      email: value.email,
      heroSlug: value.heroSlug
    };
  } catch {
    return null;
  }
}

export function rememberReturningHero(hero: ReturningHero) {
  try {
    window.localStorage.setItem(RETURNING_HERO_KEY, JSON.stringify({
      version: RETURNING_HERO_VERSION,
      displayName: hero.displayName.slice(0, 40),
      email: hero.email,
      heroSlug: hero.heroSlug
    }));
  } catch {
    // Private browsing or device policy can disable local storage.
  }
}

export function returningHeroSpriteIndex(heroSlug: string) {
  return heroSlug === "star-mage" ? 1 : 0;
}
